import React from "react";
import styles from "../style.module.scss";
import { ArrowDown, ArrowUp } from "react-bootstrap-icons";
import { Pagination, Form } from "react-bootstrap";
import { Loader } from "../../../ui";

const CoffeeSiteRewardsTable = ({
  tableData,
  pagination,
  onPageChange,
  onLimitChange,
  onSort,
  loading,
}) => {
  const totalPages = Math.ceil(pagination.total / pagination.limit);
  const currentPage = Math.floor(pagination.offset / pagination.limit) + 1;

  const handlePageChange = (pageNumber) => {
    onPageChange((pageNumber - 1) * pagination.limit);
  };

  const getSortIcon = (field) => {
    if (pagination.ordering === field) {
      return <ArrowUp />;
    } else if (pagination.ordering === `-${field}`) {
      return <ArrowDown />;
    }
    return null;
  };

  const renderPaginationItems = () => {
    let items = [];

    // Always show first page
    items.push(
      <Pagination.Item
        key={1}
        active={1 === currentPage}
        onClick={() => handlePageChange(1)}
      >
        1
      </Pagination.Item>
    );

    // Add ellipsis if needed
    if (currentPage > 3) {
      items.push(<Pagination.Ellipsis key="ellipsis1" />);
    }

    // Add pages around current page
    for (
      let number = Math.max(2, currentPage - 1);
      number <= Math.min(totalPages - 1, currentPage + 1);
      number++
    ) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    // Add ellipsis if needed
    if (currentPage < totalPages - 2) {
      items.push(<Pagination.Ellipsis key="ellipsis2" />);
    }

    // Always show last page
    if (totalPages > 1) {
      items.push(
        <Pagination.Item
          key={totalPages}
          active={totalPages === currentPage}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <>
      <div className={styles.tableContainer}>
        <table>
          <thead>
            <tr>
              <th onClick={() => onSort("id")}>Store ID {getSortIcon("id")}</th>
              <th onClick={() => onSort("name")}>
                Store Name {getSortIcon("name")}
              </th>
              <th onClick={() => onSort("total_reedems")}>
                Total Redeem {getSortIcon("total_reedems")}
              </th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr className={styles.tableLoader}>
                <td colSpan={3}>
                  <Loader />
                </td>
              </tr>
            )}
            {tableData && tableData?.length > 0 ? (
              tableData.map((data, i) => {
                return (
                  <tr key={i}>
                    <td>
                      <p>{data.id}</p>
                    </td>
                    <td>
                      <p>{data?.name}</p>
                    </td>
                    <td>
                      <p>{data?.total_reedems}</p>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={3} className={styles.noData}>
                  <p style={{ textAlign: "center" }}>No data found</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className={styles.paginationContainer}>
        <div className={styles.paginationControls}>
          <Form.Select
            value={pagination.limit}
            onChange={(e) => onLimitChange(Number(e.target.value))}
            style={{ width: "auto" }}
            disabled={loading}
            className={styles.limitSelect}
          >
            <option value={10}>10 per page</option>
            <option value={20}>20 per page</option>
            <option value={50}>50 per page</option>
            <option value={100}>100 per page</option>
          </Form.Select>

          <Pagination className={styles.pagination}>
            <Pagination.First
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1 || loading}
            />
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1 || loading}
            />

            {renderPaginationItems()}

            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages || loading}
            />
            <Pagination.Last
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages || loading}
            />
          </Pagination>
        </div>
        <div className={styles.totalItems}>Total Items: {pagination.total}</div>
      </div>
    </>
  );
};

export default CoffeeSiteRewardsTable;
